export default class IsSupported {
  static get canFileManager() {
    return (
      window.showDirectoryPicker &&
      // eslint-disable-next-line no-undef
      FileSystemDirectoryHandle &&
      // eslint-disable-next-line no-undef
      FileSystemFileHandle
    );
  }

  /**
   *
   * @param {string} osName
   * @param {string} appletVersion
   * @returns {boolean}
   */
  static canTerminal(osName, appletVersion) {
    return osIsSupported(osName) && versionIsSupported(appletVersion);
  }
}

/**
 *
 * @param {string} version
 * @returns {boolean}
 */
function versionIsSupported(version) {
  const [majorVersion, minorVersion] = version.split('.'); // 1.5.0 is the min applet version
  return +majorVersion >= 1 && +minorVersion >= 5;
}

/**
 *
 * @param {string} osName
 * @returns {boolean}
 */
function osIsSupported(osName) {
  const lowerCaseOs = osName?.toLowerCase();
  return !!(
    lowerCaseOs &&
    (lowerCaseOs.includes('mac') ||
      lowerCaseOs.includes('win') ||
      lowerCaseOs.includes('microsoft') ||
      lowerCaseOs.includes('server'))
  );
}
